import React from 'react'
import {
  type FormHelperTextProps,
  FormHelperText as MuiFormHelperText,
  useTheme,
} from '@mui/material'

import { InfoBubbleIcon } from '~assets/icons'

const FormHelperText: React.FC<
  Omit<FormHelperTextProps, 'error'> & { error?: boolean; isVisible?: boolean; icon?: boolean }
> = ({ error, isVisible = true, icon = true, ...props }) => {
  const theme = useTheme()
  return (
    <MuiFormHelperText
      error={error}
      sx={{
        color: `${error ? theme.palette.error.dark : theme.palette.text.secondary} !important`,
        minHeight: '24px',
        lineHeight: '24px',
        visibility: isVisible ? 'visible' : 'hidden',
        display: 'flex',
        gap: '8px',
        fontSize: '14px',
        alignItems: 'flex-start',
        margin: '4px 0 0 0 !important',
        padding: '0 !important',
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        '& > svg': { flexShrink: 0, marginTop: '4px' },
      }}
      {...props}
    >
      {icon && <InfoBubbleIcon error={error} />}
      {props.children}
    </MuiFormHelperText>
  )
}

export default FormHelperText
